/**
 * @preserve C.A.S./Track - Shared functions used by Track in both master
 * and the web_rewrite branch.  It uses $j to represent the jQuery object
 * here.
 *
 * Copyright (C) 2017 Software Consulting Services, LLC.
 */

var gPreflightStatuses = {
  "0": "None",
  "1": "Pending",
  "2": "Success",
  "3": "Error",
  "4": "Canceled"
};

function getPreflightInfoHtml( preflightStatus, numFiles, noneFiles,
                               pendingFiles, errorFiles, okFiles,
                               canceledFiles ) {
  var $j = jQuery,
      $info = $j( "<div/>" ),
      getFileDesc = function( n, singularDesc, pluralDesc ) {
        if ( !n || n <= 0 ) {
          return "";
        }
        else if ( n == 1 ) {
          return  n + " file " + singularDesc + "<br/>";
        }
        else if ( n > 1 ) {
          return  n + " files " + pluralDesc + "<br/>";
        }
      };

  $info.html( "<strong>" + gPreflightStatuses[preflightStatus] +
              "</strong><br/>" +
              getFileDesc( noneFiles,
                           "does not require preflight.",
                           "do not require preflight." ) +
              getFileDesc( pendingFiles,
                           "is pending.",
                           "are pending." ) +
              getFileDesc( errorFiles,
                           "has errors.",
                           "have errors." ) +
              getFileDesc( okFiles,
                           "has successfully returned from preflight.",
                           "have successfully returned from preflight." ) +
              getFileDesc( canceledFiles,
                           "canceled.",
                           "canceled." ) +
              getFileDesc( numFiles,
                           "uploaded.",
                           "uploaded." ) );
  return $info.html();
}

function cancelPreflight( fileId, callback ) {
  postJSON( "cancel_preflight", callback, { "fileId": fileId } );
}

/**
 * Get an HTML element with the appropriate icon for the preflight status.
 */
function getPreflightStatusIcon( preflightStatus, fileId, cancelCallback ) {
  var $j = jQuery;

  if ( preflightStatus == 0 ) {
    return $j( '<i class="fa fa-lg fa-minus-circle" style="color: gray;"></i>' )[0];
  }
  else if ( preflightStatus == 1 ) {
    var securityParams = getSecurityParams(),
        $pendingIcon;

    if ( fileId && securityParams["CancelPreflight"] ) {
      $pendingIcon = $j( '<i class="fa fa-lg fa-dot-circle-o" role="button" style="color: #fcbd05;" title="Click to cancel this preflight."></i>' );
      $pendingIcon.click( function() {
        confirmM( "Cancel this preflight?",
                  function() {
                    cancelPreflight( fileId, cancelCallback )
                  } );
      } );
    }
    else {
      $pendingIcon = $j( '<i class="fa fa-lg fa-dot-circle-o" style="color: #fcbd05;"></i>' );
    }

    return $pendingIcon[0];
  }
  else if ( preflightStatus == 2 ) {
    return $j( '<i class="fa fa-lg fa-check-circle-o" style="color: green;"></i>' )[0];
  }
  else if ( preflightStatus == 3 ) {
    return $j( '<i class="fa fa-lg fa-warning" style="color: red;"></i>' )[0];
  }
  else if ( preflightStatus == 4 ) {
    return $j( '<i class="fa fa-lg fa-ban"></i>' )[0];
  }
}

function getPreflightStatusFilterData() {
  $j = jQuery;
  var filterData = [];
  $j.each( [ "0", "1", "2", "3", "4" ],
           function( i, k ) {
             filterData.push( { "value": k, "display": gPreflightStatuses[k] } );
           } );
  return filterData;
}

function getAdFilePreviewUrl( adId, filename, commitHash, fileId ) {
  commitHash = commitHash || "master";
  var requestCode = window.location.search.includes( "request_code" ) ? window.location.search.match( "request_code=(.{8})" )[ 1 ] : "";
  return ( "/track/ad/" + adId + ( !!fileId ? "/git/lookup/" : "/git/blob/" )+ commitHash + ( !!fileId ? ( "/" + fileId ) : "" ) + "/" + filename ).replace( /#/g, "%23" ).replace( /\?/g, "%3F" );
}

function getAdFileRawUrl( adId, filename, commitHash ) {
  commitHash = commitHash || "master";
  return ( "/track/ad/" + adId + "/git/raw/" + commitHash + "/" + filename ).replace( /#/g, "%23" ).replace( /\?/g, "%3F" );
}

function getFileType( filename ) {
  var imageFileTypes = ["bmp", "png", "jpg", "eps", "ps", "tif", "pdf", "gif", "webp"];
  var iframeFileTypes = ["txt", "log", "html", "htm", "doc", "docx", "odt"];

  if ( filename ) {
    ext = filename.substr( filename.lastIndexOf( "." ) + 1 );

    if ( imageFileTypes.indexOf( ext ) != -1 ) {
      return "image";
    } else if ( iframeFileTypes.indexOf( ext ) != -1 ) {
      return "iframe";
    } else
      return "unknown";
  } else {
    return "unknown";
  }
}
